import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { AdvocateComplaints, Appeal } from "types";
import { LoadingIcon } from "utils/constant";
import { APPEAL_STATUS } from "utils/constantValues";
import "../../complaintRequest/styles/AddEvidenceModal.css";
import { editAppeal } from "services/prosecutorDecipilineService";
import { useTranslation } from "contexts/i18nContext";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: AdvocateComplaints;
  appealData: Appeal;
  onRefresh: any;
}

export default function UpdateAppealDocModal({
  isOpen,
  setIsOpen,
  complaintData,
  appealData,
  onRefresh,
}: ModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const [formState, setFormState] = useState({
    files: [] as File[],
  });
  const fileInputRef = useRef<HTMLInputElement>(null);

  // const handleChange = (
  //   e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  // ) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!appealData) return;

    const data = new FormData();
    data.append("memorandum_document", formState?.files[0] || "");
    data.append("appeal_type", appealData?.appeal_type || "");
    data.append("memorandum_summary", appealData?.memorandum_summary || "");
    data.append(
      "requesting_prosecutor",
      appealData?.requesting_prosecutor || "",
    );
    data.append(
      "appeal_feedback_status",
      appealData?.appeal_feedback_status || "",
    );
    // backend expects 'revision' for updated memoranda, not 'updated'
    data.append("appeal_status", APPEAL_STATUS.REVISION_REQUIRED);
    data.append("discipline_case", String(complaintData?.uu_id));

    data.append(
      "userid_requesting_prosecutor",
      appealData?.userid_requesting_prosecutor || "",
    );
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");
    data.append("accused_advocate_name", complaintData?.accused_name || "");
    data.append(
      "accused_license_number",
      complaintData?.accused_license_number || "",
    );
    data.append(
      "user_id_accused_advocate",
      complaintData?.userid_accused_name || "",
    );

    const appeal_id = appealData?.id || "";
    const isFormData = true;

    setLoading(true);
    // setError(null);
    // setSuccess(false);
    try {
      await editAppeal(data, appeal_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyUpdated"), "success");
      // setSuccess(true);
      setFormState({
        files: [] as File[],
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("updateMemorandum")}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("memorandumDocument")}
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              // multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">{t("uploadFiles")}</p>
            {formState.files.length > 0 && (
              <div className="file-list">
                {formState.files.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}...
            </div>
          ) : (
            t("submit")
          )}
        </button>
      </form>
    </SideModal>
  );
}
